export const selectForCallbackEnquiries = (state) => {
    return state.application.get('auth').get('user');
};


// WEBPACK FOOTER //
// ./src/sagas/selectors.js